module.exports = __webpack_public_path__ + "img/accuffr_ivus.23842138.png";